<template>
  <div class="cards">
    <div class="container">
      <div class="col-6 offset-3 heading">
        <h2 class="h2 cards-heading">
          {{ title }}
        </h2>
      </div>
      <div class="row">
        <div class="col col-4 sm-6">
          <div class="card">
            <IconCertificate />
            <h4 class="h4">
              Certificate of Achievement
            </h4>
            <span>
              Pass the exam, showcase your skills, and bolster your data science credentials.
            </span>
          </div>
        </div>
        <div class="col col-4 sm-6">
          <div class="card">
            <IconMonitor />
            <h4 class="h4">
              Self-Paced Learning
            </h4>
            <span>
              Enjoy maximum flexibility and forget about cramming against the clock.
            </span>
          </div>
        </div>
        <div class="col col-4 sm-6">
          <div class="card">
            <IconQaHub />
            <h4 class="h4">
              Q&A Hub
            </h4>
            <span>
              No need to do it alone – our community of learners and instructors is there for you.
            </span>
          </div>
        </div>
        <div class="col col-4 sm-6">
          <div class="card">
            <IconResumeBuilder />
            <h4 class="h4">
              Resume Builder
            </h4>
            <span>
              Write a sharp and professional resume in minutes and impress employers.
            </span>
          </div>
        </div>
        <div class="col col-4 sm-6">
          <div class="card">
            <IconUserDashboard />
            <h4 class="h4">
              User Dashboard
            </h4>
            <span>
              Learn with a sense of purpose. Track your progress, set daily goals, and make success a routine.
            </span>
          </div>
        </div>
        <div class="col col-4 sm-6">
          <div class="card">
            <IconCourseMaterials />
            <h4 class="h4">
              Course Materials
            </h4>
            <span>
              Get unlimited access to all course materials, downloadable resources, and content updates.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCertificate from '../../assets/svg/courses-landing/icon-certificate.svg?vue-component';
import IconCourseMaterials from '../../assets/svg/courses-landing/icon-course-materials.svg?vue-component';
import IconMonitor from '../../assets/svg/courses-landing/icon-monitor.svg?vue-component';
import IconQaHub from '../../assets/svg/courses-landing/icon-qa-hub.svg?vue-component';
import IconResumeBuilder from '../../assets/svg/courses-landing/icon-resume-builder.svg?vue-component';
import IconUserDashboard from '../../assets/svg/courses-landing/icon-user-dashboard.svg?vue-component';

export default {
  components: {
    IconCertificate,
    IconCourseMaterials,
    IconMonitor,
    IconQaHub,
    IconResumeBuilder,
    IconUserDashboard,
  },
  props: {
    title: { type: String, default: 'Get Lifetime Access to', required: false },
  },
};
</script>

<style lang="scss" scoped>
.cards {
  padding-bottom: var(--spacing-80);

  .heading {
    text-align: center;

    h2 {
      margin-bottom: 45px;
    }
  }

  .col {
    margin-bottom: 30px;
  }

  .card {
    text-align: center;
    height: 100%;
    padding: var(--spacing-48) var(--spacing-48) 0;
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: var(--main-dark-shade-1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    border-radius: 7px;

    svg {
      width: 64px;
      height: 64px;
      margin-bottom: var(--spacing-36);
    }

    .h4 {
      margin-bottom: var(--spacing-8);
    }

    span {
      color: var(--main-light-shade-4);
    }
  }

  @include bp($bp-laptop) {
    .card {
      padding-bottom: var(--spacing-48);
    }
  }

  @include bp($bp-mobile) {
    .card {
      padding: var(--spacing-32) var(--spacing-28);
      margin: var(--spacing-16) 0;

      .h4 {
        font-size: 21px;
      }
    }
  }
}
</style>
